import React, { useEffect, useRef } from 'react'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import CloseIcon from '@mui/icons-material/Close'
import activeAddButton from './../../containers/Products/ActiveAddButton'

const MoreIconButtonCurrentId = ({
    itemArray,
    objId,
    item,
    closeMenu,
    setCloseMenu
}) => {
    const menuRef = useRef(null)

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setCloseMenu(false)
            }
        }

        document.addEventListener('mousedown', handleOutsideClick)

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick)
        }
    }, [setCloseMenu])

    const getOptionActiveId = (obj) => {
        return obj.activeId || objId
    }

    const isOptionActive = (obj) => {
        return activeAddButton(getOptionActiveId(obj), obj.activeAddButtonItems, obj.activeType) === getOptionActiveId(obj)
    }

    const handleClick = (obj) => {
        const activeId = getOptionActiveId(obj)
        const active = isOptionActive(obj)

        if (obj.forceAction) {
            obj.onClick(item)
            setCloseMenu(false)
            return
        }

        if (obj.activeAddButtonItems && active && typeof obj.onClickDisable === 'function') {
            obj.onClickDisable(activeId, item)
            setCloseMenu(false)
            return
        }

        if (typeof obj.onClick === 'function') {
            obj.onClick(item)
        }

        setCloseMenu(false)
    }

    const renderMoreMenu = () => {
        if (!closeMenu) return null

        return (
            <div className="renderMoreMenu__mainContainer" ref={menuRef}>
                <ul>
                    {itemArray.map((obj, index) => {
                        const active = isOptionActive(obj)

                        return (
                            <li key={index} onClick={() => handleClick(obj)}>
                                <div className={`renderMoreMenu__renameIconBox ${active ? 'active' : ''}`}>
                                    {obj.icon}
                                </div>

                                <div className={`renderMoreMenu__rename ${active ? 'active' : ''}`}>
                                    {active ? obj.titleAdd : obj.title}
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    return (
        <div className="renderMoreMenu">
            {renderMoreMenu()}

            {!closeMenu
                ? <MoreVertIcon onClick={() => setCloseMenu(true)} />
                : <CloseIcon onClick={() => setCloseMenu(false)} />}
        </div>
    )
}

export default MoreIconButtonCurrentId